export const Experiments = {
  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },

  ConsumerFintech: {
    CheckoutConversion: {
      EmbeddedCheckoutF4: {
        flag: 'consumerfintech_jgcheckout_conversion_embedded_checkout_f4',
        applePayFlag:
          'consumerfintech_jgcheckout_conversion_embedded_checkout_f4_applepay',
      },
    },
  },

  AddSocialIconsToShareModal: {
    featureKey: 'consumerairwalk_legacyfrp_shareclick_social_icons',
    AddSocialIconsToShareModalExperiment: {
      experimentKey: 'consumerairwalk_legacyfrp_shareclick_social_icons',
      variations: {
        SocialIconsOnShareModal: 'social_icons_on_share_modal',
        defaultShareModal: 'default_share_modal',
      },
    },
  },

  MoveSupportersListUpThePage: {
    featureKey: 'consumerairwalk_legacyfrp_donateclick_supporters_list',
    MoveSupportersListUpThePageExperiment: {
      experimentKey: 'consumerairwalk_legacyfrp_donateclick_supporters_list',
      variations: {
        supportersAboveStory: 'supporters_above_story',
        defaultPageLayout: 'default_page_layout',
      },
    },
  },
};
